<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M12 2C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H12ZM6 3V6H3V7.5H6V13H7.5V7.5H13V6H7.5V3H6Z"
    fill="#13AF77"
  />
</template>
